import { MotifBadge, MotifButton, MotifIcon, MotifProgressBar } from '@ey-xd/motif-react'
import SelectOptions from '../atoms/SelectOptions'


import iconSvg from "../../assets/icons/icon.svg.json";
import axios from 'axios';

const ViewQuestionsUtilityBar = (props) => {
    const { content, category } = props;

    const { table, csvUrl, documentName } = content;
    const tableArray = Object.keys(table).map(key => table[key]);
    const numOfRequirements = Object.keys(tableArray[0]).length;
    const numOfRequirementsCompleted = numOfRequirements;
    const numberOFRequirementsPending = numOfRequirements - numOfRequirementsCompleted;

    const openNewTab = () => {
        axios.post("/workspace/document", {
            documentName: documentName
        }).then((response) => {
            console.log("responseresponseresponse", response);
            
            window.open(response.data.documentURL);
        }).catch(() => {
            alert("Error in fetching the document");
        })
    }

    return (
        <div className="motif-row">
            <div className="motif-col-xs-2">
            <h5 className="mt-3">
            Below listed are the questionnaire and its related suggestions:
            </h5>
            </div>
            <div className="motif-col-xs-2">
                <div className="motif-row">
                    <div className="motif-col-xs-2">
                    </div>
                        <div className="motif-col-xs-1">
                    {category && (
                            <SelectOptions />
                        )}
                        </div>
                    <div className="motif-col-xs-1 mt-3">
                        <p onClick={openNewTab} className="flex justify-center gap-2 cursor-pointer">
                        <MotifIcon src={iconSvg["excel-icon"]} className="w-5 font-[400]" title='Harrow-right' /> View  in excel
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewQuestionsUtilityBar